import CloseIcon from '@/shared/assets/icons/close.svg';
import DownloadIcon from '@/shared/assets/icons/download.svg';
import PdfIcon from '@/shared/assets/icons/files/pdf.complex.svg';
import { PrivateFileLink } from '@/shared/ui/PrivateFileLink';
import { Svg } from '@/shared/ui/Svg';
import type { FileInfo } from '@/shared/types/files';

interface RequestAttachmentListProps {
  attachments: FileInfo[];
  // Передан — значит список правится: вместо стрелки скачивания у файла появляется крестик.
  onRemove?: (attachmentKey: string) => void;
}

export const RequestAttachmentList = ({ attachments, onRemove }: RequestAttachmentListProps) => {
  if (!attachments.length) return null;

  return (
    <div className="flex flex-col gap-4">
      {attachments.map((attachment) => (
        <div
          key={attachment.key}
          className="flex h-[72px] items-center justify-between rounded-lg bg-[#F6F6F6] px-5"
        >
          <PrivateFileLink file={attachment} className="flex min-w-0 items-center gap-4">
            <Svg Icon={PdfIcon} className="h-9 w-9 shrink-0" />
            <span className="truncate text-lg font-medium">{attachment.name}</span>
          </PrivateFileLink>
          {onRemove ? (
            <button
              type="button"
              aria-label={`Remove ${attachment.name}`}
              className="shrink-0 cursor-pointer p-2"
              onClick={() => onRemove(attachment.key)}
            >
              <Svg Icon={CloseIcon} className="h-5 w-5 stroke-red" />
            </button>
          ) : (
            <Svg Icon={DownloadIcon} className="h-6 w-6 shrink-0" />
          )}
        </div>
      ))}
    </div>
  );
};
